<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'Layout'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Backstage/Layout.vue